/* eslint react/display-name: 0*/
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const cache = new Map();

const parse = (text = '', matchers = []) => {
  if (cache.has(text)) return cache.get(text);

  const matches = [];
  // Make a list of matches
  for (const matcher of matchers) {
    let match;
    while ((match = matcher.test.exec(text))) {
      matches.push({
        match: match[0],
        index: match.index,
        lastIndex: matcher.test.lastIndex,
        transform: matcher.transform
      });
    }
  }

  // Transform each match into an array of react elements
  let lastIndex = 0;
  const elements = [];
  for (const match of matches.sort((a, b) => (a.index > b.index ? 1 : 0))) {
    if (match.index > lastIndex) elements.push(text.substring(lastIndex, match.index));
    elements.push(match.transform(match.match));
    lastIndex = match.lastIndex;
  }
  if (text.length > lastIndex) {
    elements.push(text.substring(lastIndex));
  }

  cache.set(text, elements);
  return elements;
};

const Wrap = ({ children, matchers }) => {
  return <Fragment>{parse(children, matchers)}</Fragment>;
};

Wrap.propTypes = {
  children: PropTypes.string,
  matchers: PropTypes.array
};

export default Wrap;
